import { getDefaultPathForRole } from "@app/lib/auth/navigation";
import { ROLE_LABELS } from "@app/lib/role-constants";
import { getRoleLabelFromJwtRoles } from "@app/lib/role-utils";
import { useJwtAuth } from "@app/providers/jwt-auth-provider";
import { useNavigate } from "react-router";
import "./event-in-review-page.css";

type EventInReviewPageProps = {
  heading?: string;
};

export function EventInReviewPage({
  heading = "Thank you for submitting your event",
}: EventInReviewPageProps) {
  const navigate = useNavigate();
  const { user } = useJwtAuth();
  const roleLabel = getRoleLabelFromJwtRoles(user?.roles);
  const returnPath = getDefaultPathForRole(roleLabel);
  const returnLabel =
    roleLabel === ROLE_LABELS.ORGANIZER
      ? "Return to Manage Events"
      : "Return to dashboard";

  return (
    <section
      className="event-in-review"
      aria-labelledby="event-in-review-title"
    >
      <div className="event-in-review__content">
        <div className="event-in-review__icon" aria-hidden="true">
          <svg viewBox="0 0 48 48" fill="none">
            <circle
              cx="24"
              cy="24"
              r="15.5"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="m16.5 24 5 5 10.5-11"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h1 id="event-in-review-title">{heading}</h1>

        <div className="event-in-review__next">
          <h2>What&apos;s next</h2>
          <ol>
            <li>
              <span>1</span>
              <div>
                <h3>We&apos;ll review your event</h3>
                <p>
                  Our team reviews each submission to ensure everything is
                  ready.
                </p>
              </div>
            </li>
            <li>
              <span>2</span>
              <div>
                <h3>You&apos;ll receive confirmation</h3>
                <p>
                  Most events are approved within one business day. Once
                  approved, we&apos;ll email your signed agreement.
                </p>
              </div>
            </li>
            <li>
              <span>3</span>
              <div>
                <h3>Your booking site will go live</h3>
                <p>
                  Your booking site will be ready to share with attendees as
                  soon as your event is approved.
                </p>
              </div>
            </li>
          </ol>
        </div>

        <button
          type="button"
          className="event-in-review__return"
          onClick={() => navigate(returnPath, { replace: true })}
        >
          {returnLabel}
        </button>
      </div>
    </section>
  );
}
